import type { CreateNotificationTemplateInput, UpdateNotificationTemplateInput } from '@lms/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useNotificationTemplates() {
  return useQuery({
    queryKey: ['notification-templates'],
    queryFn: () => api.get('/api/notification-templates'),
  })
}

export function useCreateTemplate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateNotificationTemplateInput) =>
      api.post('/api/notification-templates', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notification-templates'] }),
  })
}

export function useUpdateTemplate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateNotificationTemplateInput }) =>
      api.put(`/api/notification-templates/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notification-templates'] }),
  })
}

export function useDeleteTemplate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.delete(`/api/notification-templates/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notification-templates'] }),
  })
}
